import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getrecurringsurveyHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "recurringsurvey", ...action.payload }),
		);
		yield put({
			type: types.GET_RECURRING_SURVEY_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_RECURRING_SURVEY_ERROR,
			payload,
		});
	}
}

export function* getrecurringsurveyWatcherSaga() {
	yield takeLatest(
		types.GET_RECURRING_SURVEY_START,
		getrecurringsurveyHandlerSaga,
	);
}

//create

//delete

function* deleterecurringsurveyHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("recurringsurvey", action.payload),
		);
		yield put({
			type: types.DELETE_RECURRING_SURVEY_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_RECURRING_SURVEY_ERROR,
			payload,
		});
	}
}

export function* deleterecurringsurveyWatcherSaga() {
	yield takeLatest(
		types.DELETE_RECURRING_SURVEY_START,
		deleterecurringsurveyHandlerSaga,
	);
}

//update
